module.exports = __webpack_public_path__ + "static/media/logo.d28548d2.png";